import React from "react"
import { useParams } from "react-router-dom"
import { HashLink as Link } from "react-router-hash-link"
import { useFetchStoreVars } from "Fetch"
import ArticleLayout from "components/ArticleLayout"
import PageHeader from "blocks/PageHeader"
import BodyText from "blocks/BodyText"
import FootnoteBody from "blocks/FootnoteBody"
import { countFootnotes } from "blocks/FootnoteBody"
import ScrollToTop from "blocks/ScrollToTop"
import Loading from "blocks/Loading"
import Login from "components/Login"
import { page as query } from "./query"
import { currentUser as currentUserQuery } from "queries/currentUser"

import "../ChapteredPage/Faq.scss"

const Book = () => {
  let { slug } = useParams()

  // Get logged-in user ID from localStorage and only allow numeric IDs.
  const storedUserId = typeof window !== "undefined" ? localStorage.getItem("userId") : null
  const parsedUserId = Number.parseInt(storedUserId, 10)
  const loggedInUserId = Number.isInteger(parsedUserId) && parsedUserId > 0 ? parsedUserId : null

  if (storedUserId && !loggedInUserId && typeof window !== "undefined") {
    localStorage.removeItem("userId")
  }

  const userData = useFetchStoreVars(currentUserQuery, { userId: loggedInUserId }, "current-user", { credentials: 'include' })
  const data = useFetchStoreVars(query, { slug: [slug] }, `book-${slug}`)

  // If no userId in localStorage, user is not logged in
  if (!loggedInUserId) {
    return <Login redirectTo={`/book/${slug}`} />
  }

  const currentUser = userData?.users?.[0]
  const isAuthenticated = !!currentUser?.id && currentUser?.status === "active"

  console.log("Current user:", currentUser, "Authenticated:", isAuthenticated, "localStorage userId:", loggedInUserId)

  if (!userData) {
    return <Loading />
  }

  if (!isAuthenticated) {
    return <Login redirectTo={`/book/${slug}`} />
  }

  if (!data) {
    return <Loading />
  }

  const page = data?.requested?.[0] || data?.fallback?.[0]

  console.log(data)

  if (!page) {
    return (
      <article className="pad center">
        <h1>Book content not found</h1>
        <p>We could not find a book page for this URL.</p>
      </article>
    )
  }

  return <Page page={page} />
}

const Page = ({ page }) => {
  const qaBlocks = page?.qabuilder || []

  return <React.Fragment>
    <PageHeader className="center pad">
      <h1>{page.title}</h1>
    </PageHeader>
    <ScrollToTop />
    <ArticleLayout side="left">
      <div className="faq-nav">
        <Nav items={qaBlocks} />
      </div>
      <div>
        <QuestionBlocks blocks={qaBlocks} />
      </div>
    </ArticleLayout>
  </React.Fragment>
}

const QuestionBlocks = ({ blocks }) => {
  let nextFootnoteNumber = 1

  const renderAnswer = (section) => {
    if (!section?.id) {
      return null
    }

    const footnoteBody = section.textWithFootnote?.html || section.textWithFootnote?.rawHtml
    const startNumber = nextFootnoteNumber

    if (footnoteBody) {
      nextFootnoteNumber += countFootnotes(footnoteBody)
    }

    return <div key={section.id}>
      {section.copy ? <h4>{section.copy}</h4> : null}
      {section.body ? <BodyText body={section.body} /> : null}
      {footnoteBody ? <FootnoteBody body={footnoteBody} startNumber={startNumber} /> : null}
    </div>
  }

  return <div>
    {blocks.map(block =>
      <div id={`question-${block.id}`} key={block.id} className="question">
        <h2>{block.heading}</h2>
        {block.children ? block.children.map(child => {
          if (child.typeHandle === "questionAnswer") {
            return <div className="question-section" key={child.id} id={`question-${child.id}`} >
              <div className="question-block article">
                {renderAnswer(child)}
              </div>
            </div>
          }

          return <div className="question-section" key={child.id} id={`question-${child.id}`} >
            <h3>{child.heading}</h3>
            <div className="question-block article">
              {child.children ? child.children.map(renderAnswer) : null}
            </div>
          </div>
        }) : null}
      </div>
    )}
  </div>
}

const Nav = ({ items }) => {
  return <ul className="faq-nav-list sticky">
    {items.map(list => <li key={list.id}>
      <Link smooth to={`#question-${list.id}`} className="section-header left" title={`scroll to ${list.heading}`}>{list.heading}</Link>
      {list.children ?
        <ul>{list.children.map(child => {
          if (child.typeHandle === "questionSection") {
            return <li key={child.id} className="section-subheader">
              <Link smooth to={`#question-${child.id}`} title={`scroll to ${child.heading}`}>{child.heading}</Link>
            </li>
          } else return null
        })}
        </ul>
        : null}
    </li>)}
  </ul>
}

export default Book
